import * as React from 'react';

import CommunicationData from '../../interfaces/CommunicationData';

interface Props {
  communicationData: CommunicationData;
}

const CommunicationTotal = (props: Props) => {

  const { communicationData } = props;
  return(
    <div className='d-flex'>
      <div className='communication-subhead'>{'Total mails for selected period: '}</div>
      <div className='communication-subtext'>
        {
          communicationData.data.length
        }
      </div>
    </div>
  );
};

export default CommunicationTotal;
